export const getFlowpageHost = (): string => {
  switch (process.env.APP_ENV) {
    case 'development':
      return `localhost:3000` // TODO: Might need to change this to 3003 for internal admin
    case 'staging':
      return `stg.flow.page`
    case 'preprod':
      return `preprod.flow.page`
    case 'production':
    default:
      return `flow.page`
  }
}

export const getFlowcodeHost = (): string => {
  switch (process.env.APP_ENV) {
    case 'development':
      return `localhost:3000`
    case 'staging':
      return `stg.flowcode.com`
    case 'preprod':
      return `preprod.flowcode.com`
    case 'production':
    default:
      return `www.flowcode.com`
  }
}
